import { api } from '@/lib/api'

export function signContract(data: {
  contractId: string
  documentId: string
  signedByFullName: string
}) {
  return api.post('/v1/me/contract-signatures', data)
}
